module.exports = __webpack_public_path__ + "img/mobile-neck-8_18x214.cb3ac653.png";